var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('navigation'),_c('v-content',[_c('router-view')],1),_c('v-footer',{attrs:{"app":"","fixed":""}},[_c('span',[_vm._v("© 2019")])]),_c('league-import')],1)}
var staticRenderFns = []

export { render, staticRenderFns }